import React from "react";
import styled from "styled-components";
import { FILES_BASE_URL } from "../../../util/constant";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1002;
`;

const Dialog = styled.div`
  margin: 0;
  font-family: Verdana, Arial, sans-serif;
  font-size: 1.1em;
  border: 1px solid #aaaaaa;
  background: #ffffff 50% 50% repeat-x;
  color: #222222;
  border-radius: 4px;
  position: relative;
  padding: 0.2em;
  width: 800px;
  // max-width: 95vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
`;

const TitleBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #eeeeee;
  padding: 0.4em 0.6em;
  border-bottom: 1px solid #cccccc;

  .title {
    font-weight: bold;
  }

  .close {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.2em;
    line-height: 1;
  }
`;

const Body = styled.div`
  padding: 1em 1.2em;
  font-size: 0.95em;
  line-height: 1.5;
  overflow-y: auto;

  h3 {
    margin-top: 0;
    font-size: 1.3em;
    color: ${({ colors }) => colors?.labelText || "#222"};
  }

  p {
    margin: 0 0 1em;
  }

  ol {
    margin: 0 0 1em 1.2em;
    padding: 0;
  }

  li {
    margin-bottom: 0.6em;
  }
`;

const Footer = styled.div`
  padding: 0.6em;
  text-align: right;
  border-top: 1px solid #cccccc;
`;

const CloseButton = styled.button`
  padding: 0.4em 1.1em;
  font-size: 0.9em;
  border: 1px solid #888888;
  background: #f0f0f0;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background: #e0e0e0;
  }
`;

const QuickStartModal = ({ show, onClose, colors }) => {
  if (!show) return null;
  const statTemplateUrl = `${FILES_BASE_URL}/ISAFE_STAT_Sheet.csv`;

  return (
    <Overlay>
      <Dialog role="dialog" aria-modal="true" aria-labelledby="quick_start_title">
        <TitleBar>
          <span className="title" id="quick_start_title">Quick Start</span>
          <button className="close" onClick={onClose} aria-label="Close">×</button>
        </TitleBar>
        <Body colors={colors}>
          <h3>Quick Start for Curriculum Subscriptions</h3>
          <p>
            An appropriate starting point to begin implementing your curriculum subscription is for you to complete and submit to ISAFE your STAT (Subscription Teachers Action Table). You can do that online through this Admin Central portal or via e-mail.
          </p>
          <p>To submit your STAT online: From the navigation bar, click on Teachers and select the Teachers tab from the menu. Then, follow these simple instructions to complete and submit your STAT electronically:</p>
          <ol>
            <li>From the left side Actions buttons, click <strong>Download Blank STAT</strong>.</li>
            <li>Complete all fields of the spreadsheet and save to your computer.</li>
            <li>Click <strong>Import Teacher List</strong>, browse and find the STAT spreadsheet you saved to your computer.</li>
            <li>Click <strong>Import</strong> and your STAT is uploaded, and those designated teachers now have active ISAFE accounts.</li>
            <li>An auto-e-mail is generated and sent to all teachers named on your STAT sheet.</li>
          </ol>
          <p>
            If you're an administrator and you also want access to the curriculum, it is necessary that your name and contact information be included within the STAT.
          </p>
          <p>
            Blue Ribbon Customer Service Program members may return your STAT via e-mail: <a href={statTemplateUrl} target="_blank" rel="noreferrer">Click to download the STAT template</a>. Return the completed STAT to: <a href="mailto:subscription@isafe.org">subscription@isafe.org</a>.
          </p>
          <p>
            After ISAFE receives your STAT it typically takes 3-5 days for the information to be entered into our system. Once entered, you will be asked to approve an ISAFE "Welcome E-mail" to be sent to all the individuals designated on your STAT. The e-mail contains information about how your educators electronically access their curriculum resources. You have the flexibility to send this e-mail yourself or delegate that task to ISAFE. Subscribers interested in enrolling in the Blue Ribbon Customer Service Program contact ISAFE at <a href="mailto:subscription@isafe.org">subscription@isafe.org</a>.
          </p>
          <p>
            An alternate option to creating user accounts via a STAT is an online form that an educator can use to self-enroll for curriculum access. This solution is called an "Online Registration." Online Registration is also a management feature of the Admin Central portal. Refer to the Guide/FAQ posted on the site for easy step-by-step directions in which your educators enroll using a unique code. Also, refer to the Guide/FAQ for step-by-step directions for other Admin Central management features including generating on demand implementation tracking reports.
          </p>
          <p>
            You will soon be receiving a CD/DVD subscription packet in the mail. All the information you need regarding implementing and managing your ISAFE curriculum subscription is contained within Disk 1 (CD); the media files which can be hosted on your district/school server are contained within the DVD(s).
          </p>
        </Body>
        <Footer>
          <CloseButton onClick={onClose}>Close</CloseButton>
        </Footer>
      </Dialog>
    </Overlay>
  );
};

export default QuickStartModal;
